// removed by extract-text-webpack-plugin
module.exports = {"Select":"Select","Select-menu-outer":"Select-menu-outer","Select-option-group-label":"Select-option-group-label"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Form/Fields/ReactSelectPlus.scss
// module id = 18aU
// module chunks = 0